import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

/** Presentational bell icon — click handling belongs on the parent button. */
const Bellicon = () => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '1px',
      fontSize: 'inherit',
      color: 'inherit',
      lineHeight: 1,
      pointerEvents: 'none',
    }}
    aria-hidden="true"
  >
    <FontAwesomeIcon icon={faBell} />
  </span>
);

export default Bellicon;
